module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "pdyx"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/flat/pc/my-xy.png"),
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3934d714"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Pdxy.vue
// module id = 392
// module chunks = 1